import { useIsMobile } from "@/hooks/useIsMobile";
import React, { PropsWithChildren } from "react";
import PageDrawer from "../../lib/modal-as-page/PageDrawer";
import { Modal } from "react-bootstrap";
import {
  PopupValue,
  ProductReviewAtomProps,
} from "@/utils/factory/createPopupAtom";

const ReviewsModal: React.FC<
  PropsWithChildren<{
    title: string;
    popupValue: PopupValue;
    handleClosePopup: () => void;
    ModalActionBtn?: React.ReactElement;
    autoHieght?: boolean;
  }>
> = ({
  children,
  title,
  handleClosePopup,
  popupValue,
  ModalActionBtn,
  autoHieght,
}) => {
  const productId = isProductReviewAtomProps(popupValue)
    ? popupValue.product_id
    : popupValue;

  const isMobile = useIsMobile();
  if (isMobile)
    return (
      <PageDrawer
        padding="24px 16px 100px 16px"
        title={title}
        show={!!productId}
        setShow={handleClosePopup}
      >
        <div
          className={`product-review-container m-0 p-0 w-100 ${
            autoHieght ? "h-auto" : ""
          }`}
        >
          {children}
        </div>
        {ModalActionBtn}
      </PageDrawer>
    );
  return (
    <Modal
      centered
      show={!!productId}
      onHide={handleClosePopup}
      dialogClassName={"messagebox-dialog"}
      contentClassName="pop-up-modal-contents"
    >
      <h2 className="product-review-title">{title}</h2>
      <div
        className={`product-review-container  ${autoHieght ? "h-auto" : ""}`}
      >
        {children}
      </div>
    </Modal>
  );
};
const isProductReviewAtomProps = (
  value: any,
): value is ProductReviewAtomProps => {
  return (value as ProductReviewAtomProps)?.product_id !== undefined;
};

export default ReviewsModal;
